import React, { useEffect, useState } from "react";
import axios from "axios";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

// ✅ SWIPER
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const EventsCarousel = () => {
  const [events, setEvents] = useState([]);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const API =
    "https://login.abhedasramam.org/myapp/api/uploads/get_event.php";
  const BASE_URL = "https://login.abhedasramam.org/myapp/";

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(API);
      setEvents(res.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getFileUrl = (item) => {
    const file = item.file_path || "";
    if (!file) return "";
    if (file.startsWith("http")) return file;
    return BASE_URL + file;
  };

  const isPDF = (url) =>
    typeof url === "string" && url.toLowerCase().endsWith(".pdf");

  return (
    <div style={{ padding: "10px 5px" }}>
      <h2 style={titleStyle}>Latest Events</h2>

      {/* ✅ SWIPER */}
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={10}
        slidesPerView={1} // ✅ ALWAYS 1 ON MOBILE
        breakpoints={{
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        }}
      >
        {events.map((item, index) => {
          const fileUrl = getFileUrl(item);

          return (
            <SwiperSlide key={index}>
              <div style={cardStyle}>
                {fileUrl ? (
                  isPDF(fileUrl) ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={buttonStyle}
                    >
                      View More
                    </a>
                  ) : (
                    <img
                      src={fileUrl}
                      alt={item.name}
                      style={imgStyle}
                      onClick={() => {
                        setPhotoIndex(index);
                        setIsOpen(true);
                      }}
                    />
                  )
                ) : (
                  <p>No File</p>
                )}

                <h3 style={textStyle}>
                  {item.name || "No Title"}
                </h3>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* LIGHTBOX */}
      {isOpen && (
        <Lightbox
          mainSrc={getFileUrl(events[photoIndex])}
          nextSrc={getFileUrl(events[(photoIndex + 1) % events.length])}
          prevSrc={getFileUrl(
            events[(photoIndex + events.length - 1) % events.length]
          )}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + events.length - 1) % events.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % events.length)
          }
        />
      )}
    </div>
  );
};

/* ✅ STYLES */

const titleStyle = {
  textAlign: "center",
  marginBottom: "20px",
  fontSize: "18pt",
  fontWeight: "600",
};

const cardStyle = {
  width: "100%",
  padding: "10px",
  background: "#fff",
  borderRadius: "10px",
  border: "2px groove orange",
  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  boxSizing: "border-box",
};

const imgStyle = {
  width: "100%",
  height: "260px",
  objectFit: "cover",
  borderRadius: "10px",
  cursor: "pointer",
  marginBottom: "10px",
};

const textStyle = {
  textAlign: "center",
  fontSize: "14pt",
  fontWeight: "600",
  fontFamily: "anek malayalam",
};

const buttonStyle = {
  display: "inline-block",
  padding: "10px 18px",
  background: "#007bff",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
  fontWeight: "bold",
};

export default EventsCarousel;